import { __require as requireRe } from "./internal/re.js";
import { __require as requireConstants } from "./internal/constants.js";
import { __require as requireSemver$1 } from "./classes/semver.js";
import { __require as requireIdentifiers } from "./internal/identifiers.js";
import { __require as requireParse } from "./functions/parse.js";
import { __require as requireValid } from "./functions/valid.js";
import { __require as requireClean } from "./functions/clean.js";
import { __require as requireInc } from "./functions/inc.js";
import { __require as requireDiff } from "./functions/diff.js";
import { __require as requireMajor } from "./functions/major.js";
import { __require as requireMinor } from "./functions/minor.js";
import { __require as requirePatch } from "./functions/patch.js";
import { __require as requirePrerelease } from "./functions/prerelease.js";
import { __require as requireCompare } from "./functions/compare.js";
import { __require as requireRcompare } from "./functions/rcompare.js";
import { __require as requireCompareLoose } from "./functions/compare-loose.js";
import { __require as requireCompareBuild } from "./functions/compare-build.js";
import { __require as requireSort } from "./functions/sort.js";
import { __require as requireRsort } from "./functions/rsort.js";
import { __require as requireGt } from "./functions/gt.js";
import { __require as requireLt } from "./functions/lt.js";
import { __require as requireEq } from "./functions/eq.js";
import { __require as requireNeq } from "./functions/neq.js";
import { __require as requireGte } from "./functions/gte.js";
import { __require as requireLte } from "./functions/lte.js";
import { __require as requireCmp } from "./functions/cmp.js";
import { __require as requireCoerce } from "./functions/coerce.js";
import { __require as requireComparator } from "./classes/comparator.js";
import { __require as requireRange } from "./classes/range.js";
import { __require as requireSatisfies } from "./functions/satisfies.js";
import { __require as requireToComparators } from "./ranges/to-comparators.js";
import { __require as requireMaxSatisfying } from "./ranges/max-satisfying.js";
import { __require as requireMinSatisfying } from "./ranges/min-satisfying.js";
import { __require as requireMinVersion } from "./ranges/min-version.js";
import { __require as requireValid$1 } from "./ranges/valid.js";
import { __require as requireOutside } from "./ranges/outside.js";
import { __require as requireGtr } from "./ranges/gtr.js";
import { __require as requireLtr } from "./ranges/ltr.js";
import { __require as requireIntersects } from "./ranges/intersects.js";
import { __require as requireSimplify } from "./ranges/simplify.js";
import { __require as requireSubset } from "./ranges/subset.js";
var semver;
var hasRequiredSemver;
function requireSemver() {
  if (hasRequiredSemver) return semver;
  hasRequiredSemver = 1;
  const internalRe = requireRe();
  const constants = requireConstants();
  const SemVer = requireSemver$1();
  const identifiers = requireIdentifiers();
  const parse = requireParse();
  const valid = requireValid();
  const clean = requireClean();
  const inc = requireInc();
  const diff = requireDiff();
  const major = requireMajor();
  const minor = requireMinor();
  const patch = requirePatch();
  const prerelease = requirePrerelease();
  const compare = requireCompare();
  const rcompare = requireRcompare();
  const compareLoose = requireCompareLoose();
  const compareBuild = requireCompareBuild();
  const sort = requireSort();
  const rsort = requireRsort();
  const gt = requireGt();
  const lt = requireLt();
  const eq = requireEq();
  const neq = requireNeq();
  const gte = requireGte();
  const lte = requireLte();
  const cmp = requireCmp();
  const coerce = requireCoerce();
  const Comparator = requireComparator();
  const Range = requireRange();
  const satisfies = requireSatisfies();
  const toComparators = requireToComparators();
  const maxSatisfying = requireMaxSatisfying();
  const minSatisfying = requireMinSatisfying();
  const minVersion = requireMinVersion();
  const validRange = requireValid$1();
  const outside = requireOutside();
  const gtr = requireGtr();
  const ltr = requireLtr();
  const intersects = requireIntersects();
  const simplifyRange = requireSimplify();
  const subset = requireSubset();
  semver = {
    parse,
    valid,
    clean,
    inc,
    diff,
    major,
    minor,
    patch,
    prerelease,
    compare,
    rcompare,
    compareLoose,
    compareBuild,
    sort,
    rsort,
    gt,
    lt,
    eq,
    neq,
    gte,
    lte,
    cmp,
    coerce,
    Comparator,
    Range,
    satisfies,
    toComparators,
    maxSatisfying,
    minSatisfying,
    minVersion,
    validRange,
    outside,
    gtr,
    ltr,
    intersects,
    simplifyRange,
    subset,
    SemVer,
    re: internalRe.re,
    src: internalRe.src,
    tokens: internalRe.t,
    SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: constants.RELEASE_TYPES,
    compareIdentifiers: identifiers.compareIdentifiers,
    rcompareIdentifiers: identifiers.rcompareIdentifiers
  };
  return semver;
}
export {
  requireSemver as __require
};
//# sourceMappingURL=index.js.map
